import type { ComponentType } from 'react';
import type { MethodContent, MethodLayout } from '@/types/methodologies';
import { CardsView } from './CardsView';
import { HadiView } from './HadiView';
import { LeanCanvasView } from './LeanCanvasView';
import { SwotView } from './SwotView';
import { CjmView } from './CjmView';
import { SurveyView } from './SurveyView';
import { RiskRegisterView } from './RiskRegisterView';

export interface MethodViewProps {
  methodId: string;
  content: MethodContent;
}

/**
 * Layout → renderer registry. `document` has no dedicated layout in wave A
 * (falls back to CardsView, which degrades gracefully for a single section).
 * `survey` is F-03's only new layout — `custdev-questions` and
 * `research-analysis` (also F-03) reuse `cards`. `risk-register` (F-02.B) is
 * the only new layout of waves B/C — MoSCoW, CRAFT, SCAMPER and TRIZ reuse `cards`.
 */
export const METHOD_VIEW_REGISTRY: Partial<Record<MethodLayout, ComponentType<MethodViewProps>>> = {
  cards: CardsView,
  hadi: HadiView,
  'lean-canvas': LeanCanvasView,
  swot: SwotView,
  cjm: CjmView,
  document: CardsView,
  survey: SurveyView,
  'risk-register': RiskRegisterView,
};

export function getMethodView(layout: MethodLayout): ComponentType<MethodViewProps> {
  return METHOD_VIEW_REGISTRY[layout] ?? CardsView;
}

export { CardsView, LeanCanvasView, SwotView, CjmView, SurveyView, RiskRegisterView };
